import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { equalisations as rules } from 'further-ui/validations';
import { z } from 'zod';

export type EqualisationFeesFormValues = z.infer<
  typeof rules.EqualisationsTotalCommitmentFeesFormSchema
>;

type Props = {
  values: EqualisationFeesFormValues;
  children: React.ReactNode;
};

const FormWrapper: React.FC<Props> = ({ children, values }) => {
  const formMethods = useForm<EqualisationFeesFormValues>({
    shouldFocusError: true,
    resolver: zodResolver(rules.EqualisationsTotalCommitmentFeesFormSchema),
    defaultValues: values,
    criteriaMode: 'all',
    reValidateMode: 'onChange',
  });

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};

export default FormWrapper;
